
import React, { Fragment, useState } from 'react'
import {AppButton,AppRow,AppGridBar,AppForm,AppGridTabs, AppTable} from 'qcc'
import { Row, Icon ,Col} from 'antd';
import api, {PosLoginInput,PosLoginResult} from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'

let inputConfig = {
    example : {account:"zhusg",password:"123456",mac:"00-01-02-03-04-05"} as PosLoginInput,
    formdata:{} as PosLoginInput,
    labelWidth:100 ,
    items:
    [
        {lable:'账号',field:'account',placeholder:'string类型'},
        {lable:'密码',field:'password',placeholder:'string类型'},
        {lable:'mac',field:'mac',placeholder:'string类型，设备的MAC地址'},
    ]
} as PosLoginInput;

let outputExample = {
    msg:'',
    result:true,
    data:{
            token:'heriuwqheruywrnbt',
            userId:9993333,
            userName:'test',
            projectList:[
                {id:1,name:'A项目'},
                {id:2,name:'B项目'}
            ]
        } 
} as PosLoginResult

export const AppLogin = () =>{

    const[outputResult,setOutputResult]  = useState(null as PosLoginResult)
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let inputParam = refPosApiInputContent.current.getFormData();
        let res = await api.public.posapp.login(inputParam);
        setOutputResult(res);
    }

    const renderOutput = () =>{
        console.log('outputResult:',outputResult)
        if(outputResult===null) return '';

        switch(outputView){
            case 0:
            return renderOutputForm();
            case 1:
            return renderOutputFormData();
            case 2:
            return renderOutputProjectTable();
            case 3:
            return renderJson();
        }

        return '';
    }

    const renderOutputForm = () =>{
        return ( <AppForm  loadingData={false} formData={{...outputResult}}>
            <AppForm.Section labelWidth={150}>
                <AppForm.Item label='失败信息（msg）:' field='msg' itemType='input' readonly/>
                <AppForm.Item label='结果（result）:' field='result' itemType='input' readonly/>
            </AppForm.Section>
        </AppForm>)
    }

    const renderOutputProjectTable = () =>{
        let list = null;
        if(outputResult.data && outputResult.data.projectList){
            list = outputResult.data.projectList
        }
        if(list){
            return ( <AppTable  dataSource={list}>
               <AppTable.ColIndex />
               <AppTable.Col field='id' width={100}/>
               <AppTable.Col field='name' />
            </AppTable>)
        }else{
            return null;
        }
       
    }

    const renderOutputFormData  = () =>{
        let data = outputResult.data || {};
        return ( <AppForm  loadingData={false} formData={{...data}}>
            <AppForm.Section labelWidth={120}>
                <AppForm.Item label='token' field='token'  />
                <AppForm.Item label='userId' field='userId' />
                <AppForm.Item label='userName' field='userName'/>
            </AppForm.Section>
        </AppForm>)
    }

    const renderJson = () =>{
        return <pre>{JSON.stringify(outputResult, null, 4)}</pre>
    } 
    
    let refPosApiInputContent = React.createRef<PosApiInputContent>();
    return (<div className='app-demo-content'>
            <h1>PosApp登录</h1>    
            <div>
                1、Pos端登录使用<br/>
                2、地址：/api/public/posApp/login <br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent ref={refPosApiInputContent} config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['表单（LoginResult）','表单（LoginResult.data）','列表（projectList）','JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={16} className='app-pos-api-input-form'>
                        {renderOutput()}
                    </Col>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>

            
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/posapi/app/AppLogin.tsx